// utils/currencyFormatter.js

export function FormatCurrencyLKR(amount) {
  if (isNaN(amount)) return "0";

  return `${new Intl.NumberFormat("en-LK", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true, // Enables thousand separators
  }).format(amount)}`;
}

export function FormatamountWithoutDecimal(amount) {
  if (isNaN(amount)) return "0";

  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 0, // No decimals
    useGrouping: true, // Enables thousand separators
  }).format(amount);
}

export function formatWithCommas(value) {
  if (value === null || value === undefined || isNaN(value)) return "-";

  return Number(value).toLocaleString("en-US");
}

export function allowOnlyNumbersCommaDot(value) {
  // Remove any non-numeric characters except commas and dots
  const sanitizedValue = value.replace(/[^0-9.,]/g, "");

  // Remove commas for easier parsing
  const numericValue = sanitizedValue.replace(/,/g, "");

  return numericValue;
}

export function allowOnlyNumbers(value) {
  // Convert null/undefined/numbers to string safely
  if (typeof value !== 'string') {
    value = String(value ?? '');
  }

  // Remove any non-numeric characters except commas and dots
  const sanitizedValue = value.replace(/[^0-9.,]/g, '');

  // Remove commas for easier parsing
  const numericValue = sanitizedValue.replace(/,/g, '');

  return numericValue;
}

/**
 * Format currency value for editable input fields with thousand separators
 * @param {string|number} value - The value to format
 * @returns {string} - Formatted string with thousand separators
 */
export function formatCurrencyForInput(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  // Convert to string and remove any existing commas
  let stringValue = String(value).replace(/,/g, '').trim();
  
  // If empty after removing commas, return empty string
  if (stringValue === '' || stringValue === '.') {
    return stringValue;
  }

  // Handle negative sign if present
  const isNegative = stringValue.startsWith('-');
  if (isNegative) {
    stringValue = stringValue.substring(1);
  }

  // Split by decimal point to handle decimals separately
  const parts = stringValue.split('.');
  let integerPart = parts[0] || '';
  const decimalPart = parts[1];

  // If integer part is empty (user typing decimal first like ".5"), return as-is
  if (integerPart === '') {
    const decimalStr = decimalPart !== undefined ? `.${decimalPart}` : '';
    return isNegative ? `-${decimalStr}` : decimalStr;
  }

  // Format integer part with thousand separators
  // Only format if it contains digits
  if (/^\d+$/.test(integerPart)) {
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Combine with decimal part if exists
  const result = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
  
  return isNegative ? `-${result}` : result;
}

/**
 * Parse formatted currency string back to numeric value (removes commas)
 * @param {string} value - The formatted string value
 * @returns {string} - Numeric string without commas
 */
export function parseCurrencyFromInput(value) {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  // Convert to string and remove commas
  const stringValue = String(value).replace(/,/g, '');
  
  return stringValue;
}
